import styles from './delete-customer-group-dialog.module.scss';
import { useContext } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, SecondaryButton, SnackBarContext, Typography } from '@frontend-workspace/react-shared-lib';
import { ICustomerGroupCompanies } from '../../_models/customer-group-companies';
import { useTranslation } from 'react-i18next';
import { useMakeRequestHook } from '../../requestUtils';

/* eslint-disable-next-line */
export interface DeleteCustomerGroupDialogProps {
  open: boolean,
  onClose: () => void,
  deleteCustomerGroup: ICustomerGroupCompanies,
  companyNumber: string
}

export function DeleteCustomerGroupDialog(props: DeleteCustomerGroupDialogProps) {
  const { t } = useTranslation();
  const makeRequest = useMakeRequestHook();
  const { setSnackbarMessage } = useContext(SnackBarContext);

  const handleDelete = () => {
    makeRequest(`companies/${props.deleteCustomerGroup?.companyNumber}/action/removeFromGroup`, 'DELETE')
      .then(result => {
        setSnackbarMessage({ content: t('deleteCustomerGroup.customerGroupDeleted'), type: "success" });
        props.onClose();
      }).catch(() => setSnackbarMessage({ content: t('deleteCustomerGroup.couldNotDeleteCustomerGroup'), type: "error" }));
  };

  return (
    <Dialog
      open={props.open}
      onClose={() => props.onClose()}
      maxWidth="md">
      <DialogTitle className='mb-4'>
        {t('deleteCustomerGroup.areYouSureYouWantToDeleteCompanyDepartment')}
      </DialogTitle>
      <DialogContent>
        <Typography
          component="div"
          variant='subtitle3'
          className='mb-3'>
          {props.deleteCustomerGroup?.name}
        </Typography>
      </DialogContent>
      <DialogActions>
        <SecondaryButton
          variant="contained"
          size='large'
          onClick={handleDelete}
          className='minButtonWidth'>
          {t('standard.delete')}
        </SecondaryButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t('standard.cancel')}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteCustomerGroupDialog;